import React from "react";
import { FaGithub, FaLinkedin,  } from 'react-icons/fa';

function Footer() {

    return (
        <footer className="bg-[#c3b091] shadow-2xl drop-shadow-lg px-6 py-6 md:px-20">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                <div className="text-center md:text-left">
                    <span className="text-black hover:text-[#80755a] font-semibold text-lg" href="#">
                      Nimrekha 
                    </span>
                    <span className="text-[#a0522d] mx-1 hover:text-[#c19a6b] font-semibold text-lg" href="#">
                      Weerasinghe
                    </span>
                </div>
            </div>
            

            <div className="flex flex-col items-center md:items-end space-y-3">
                <ul className="flex space-x-6">
                    <li>
                        <a href="https://github.com/WeerasingheN-T" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 text-[#321414]">
                           <FaGithub className="text-2xl"/>
                        </a>
                    </li>
                    <li>
                       <a href="https://www.linkedin.com/in/nimrekha-weerasinghe-868283227/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 text-[#321414]">
                           <FaLinkedin className="text-2xl"/>
                        </a>
                    </li>
                </ul>
                <div>
                   <p className="text-black text-sm">© 2025 Nimrekha Weerasinghe. All rights reserved.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;